import { useMemo } from 'react'
import { ThemeProvider, CssBaseline } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'
import { createTheme, alpha } from '@mui/material/styles'
// #03030f


// TODO: primary #02ccaf

const primaryHue = '#18eaed';
const primaryHueDark = '#00c7c8';
const primaryHueLight = '#6af4f6';
const secondaryHue = '#7b68ff';
const secondaryHueDark = '#5a42ff';
const secondaryHueLight = '#a598ff';

const darkTheme = createTheme(
  createTheme({ palette: { mode: 'dark' } }), {
    palette: {
      primary: { 
        main: primaryHue, 
        light: primaryHueLight, 
        dark: primaryHueDark, 
        contrastText: '#021012' 
      },
      // secondary: { main: secondaryHue, light: secondaryHueLight, dark: secondaryHueDark, contrastText: '#0b0618' },
      // background: {
      //   default: '#000f39',
      //   paper: '#001747',
      // },
      background: {
        default: '#0b132c',
        paper: '#272e42',
      },
      // divider: 'rgba(255,255,255,0.12)',
      // text: { primary: 'rgba(255,255,255,0.92)', secondary: 'rgba(255,255,255,0.7)' },
      error: { main: '#fe1048', dark: '#c80036', light: '#ff456e', darker: '#870029' },
      // background: {
      //   default: '#0c111f',
      //   paper: 'rgb(17 21 32 / 84%)',
      //   opaque: '#060914d9',
      //   bold: '#060914c2',
      // },
    },
  }
);
const lightTheme = createTheme(
  createTheme({ palette: { mode: 'light' } }), {
    palette: {
      primary: { 
        main: '#0019df',//'#008abb', 
        light: '#7584f9', //'#74d6eb', 
        dark: '#172060', //'#005f7a', 
        contrastText: '#ffffff'
        // contrastText: '#011012' 
      },
      // secondary: { main: secondaryHue, light: secondaryHueLight, dark: secondaryHueDark, contrastText: '#0b0618' },
      background: { default: '#f2f6fb', paper: '#ffffffef' },
      // divider: 'rgba(0,0,0,0.08)',
      // text: { primary: 'rgba(2,6,23,0.92)', secondary: 'rgba(2,6,23,0.6)' },
      // background: {
      //   default: '#f2f6fb',
      //   paper: '#ffffffef',
      //   opaque: '#ffffffd9',
      //   bold: '#ffffffc2',
      // },
    },
  }
);

export type ThemeMode = 'light' | 'dark'

export default function Theme({
  children,
  mode,
  enableCssBaseline = true,
}: {
  children: React.ReactNode
  mode?: ThemeMode
  enableCssBaseline?: boolean
}) {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)')
  const darkMode = mode ? mode === 'dark' : prefersDarkMode
  // console.log('Prefers dark mode:', prefersDarkMode)
  const theme = useMemo(() => {
    const theme = darkMode ? darkTheme : lightTheme;
    return createTheme(theme, {
      // breakpoints: {
      //   values: {
      //     xxs: 0,
      //     xs: 0,
      //     sm: 600,
      //     md: 900,
      //     lg: 1200,
      //     xl: 1536,
      //     xxl: 1920,
      //   },
      // },
      typography: {
        fontSize: 18,
        htmlFontSize: 16,
      },
      palette: {
        error: { main: '#fe1048', dark: '#c80036', light: '#ff456e', darker: '#870029' },
        // background: {
        //   default: prefersDarkMode ? '#0c111f' : '#f2f6fb',
        //   paper: prefersDarkMode ? 'rgb(17 21 32 / 84%)' : '#ffffffef',
        //   opaque: prefersDarkMode ? '#060914d9' : '#ffffffd9',
        //   bold: prefersDarkMode ? '#060914c2' : '#ffffffc2',
        // },
      },
      shape: { borderRadius:6 },
      components: {
          MuiBackdrop: {
            styleOverrides: {
              root: {
                // background-color: rgb(96 126 156 / 77%);
                // backdrop-filter: blur(2px) brightness(2);
                // backgroundColor: alpha(theme.palette.background.paper, 0.8),
                // backdropFilter: 'blur(4px) saturate(1.1)',
                // backgroundColor: 'rgb(96 126 156 / 77%)',
                backdropFilter: 'blur(3px) brightness(1.05)',
              },
            },
          },
          // rgb(17 21 32 / 84%)
          MuiDialog: {
            styleOverrides: {
              paper: {
                backgroundImage: 'none',
                // backgroundColor: 'rgb(17 21 32 / 84%)',
                backgroundColor: alpha(theme.palette.background.paper, 0.96),
                // backdropFilter: 'blur( 4px) saturate(1.1)',
                // WebkitBackdropFilter: 'blur( 4px) saturate(1.1)',
                // border: '1px solid rgba(255,255,255,0.12)',
                // boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
              },
            },
          },
          MuiPaper: {
            styleOverrides: {
              root: {
                backgroundImage: 'none',
                // color: 'rgba(255,255,255,0.92)',
                // backdropFilter: 'blur(8px) saturate(1.05)',
                // WebkitBackdropFilter: 'blur(8px) saturate(1.05)',
                // border: '1px solid rgba(255,255,255,0.08)',
                // boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
                backgroundColor: alpha(theme.palette.background.paper, 0.96), backdropFilter: 'blur( 0px) saturate(1.02)', WebkitBackdropFilter: 'blur( 0px) saturate(1.02)'
              },
            },
            variants: [
              // { props: { elevation: 0 }, style: { backdropFilter: 'blur(0px) saturate(1.02)', WebkitBackdropFilter: 'blur(0px) saturate(1.02)', boxShadow: '0 2px 2px rgba(0,0,0,0.18)' } },
              // { props: { elevation: 1 }, style: { backdropFilter: 'blur(2px) saturate(1.06)', WebkitBackdropFilter: 'blur(2px) saturate(1.06)', boxShadow: '0 6px 8px rgba(0,0,0,0.28)' } },
              // { props: { elevation: 2 }, style: { backdropFilter: 'blur(4px) saturate(1.08)', WebkitBackdropFilter: 'blur(4px) saturate(1.08)', boxShadow: '0 8px 24px rgba(0,0,0,0.28)' } },
              // { props: { elevation: 3 }, style: { backdropFilter: 'blur(12px) saturate(1.1)', WebkitBackdropFilter: 'blur(12px) saturate(1.1)', boxShadow: '0 10px 28px rgba(0,0,0,0.38)' } },
              { props: { elevation: 0 }, style: { backgroundColor: alpha(theme.palette.background.paper, 0.96), backdropFilter: 'blur( 0px) saturate(1.02)', WebkitBackdropFilter: 'blur( 0px) saturate(1.02)' } },
              { props: { elevation: 1 }, style: { backgroundColor: alpha(theme.palette.background.paper, 0.84), backdropFilter: 'blur( 2px) saturate(1.06)', WebkitBackdropFilter: 'blur( 2px) saturate(1.06)' } },
              { props: { elevation: 2 }, style: { backgroundColor: alpha(theme.palette.background.paper, 0.72), backdropFilter: 'blur( 4px) saturate(1.08)', WebkitBackdropFilter: 'blur( 4px) saturate(1.08)', boxShadow: '0 2px  6px rgba(0,0,0,0.28)' } },
              { props: { elevation: 3 }, style: { backgroundColor: alpha(theme.palette.background.paper, 0.60), backdropFilter: 'blur(12px) saturate(1.10)', WebkitBackdropFilter: 'blur(12px) saturate(1.10)', boxShadow: '0 2px 12px rgba(0,0,0,0.28)' } },
              { props: { elevation: 4 }, style: { backgroundColor: alpha(theme.palette.background.paper, 0.40), backdropFilter: 'blur(16px) saturate(1.12)', WebkitBackdropFilter: 'blur(16px) saturate(1.12)', boxShadow: '0 2px 16px rgba(0,0,0,0.28)' } },
              { props: { elevation: 5 }, style: { backgroundColor: alpha(theme.palette.background.paper, 0.10), backdropFilter: 'blur(18px) saturate(1.13)', WebkitBackdropFilter: 'blur(18px) saturate(1.13)', boxShadow: '0 2px 18px rgba(0,0,0,0.28)' } },
              { props: { elevation: 6 }, style: { backgroundColor: alpha(theme.palette.background.paper, 0.00), backdropFilter: 'blur(20px) saturate(1.14)', WebkitBackdropFilter: 'blur(20px) saturate(1.14)', boxShadow: '0 2px 20px rgba(0,0,0,0.28)' } },
            ]
          },
          MuiAppBar: {
            styleOverrides: {
              root: {
                backgroundColor: alpha(theme.palette.background.paper, 0.0),
                backgroundImage: 'none',
                // backdropFilter: 'blur(4px) saturate(1.1)',
                // WebkitBackdropFilter: 'blur(4px) saturate(1.1)',
                // borderBottom: `1px solid ${alpha(theme.palette.divider, 0.8)}`,
              },
            },
          },
        // MuiButton: { styleOverrides: { root: { textTransform: 'none', borderRadius: 10 } } },
        MuiTooltip: {
        //   defaultProps: { arrow: true },
          styleOverrides: {
            arrow: {
              color: theme.palette.background.paper,
            },
            tooltip: {
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.text.primary,
        //       backgroundColor: 'rgba(17,24,39,0.92)',
        //       color: 'white',
        //       backdropFilter: 'blur(6px)',
        //       WebkitBackdropFilter: 'blur(6px)',
        //       border: '1px solid rgba(255,255,255,0.1)'
            },
        //     arrow: { color: 'rgba(17,24,39,0.92)' }
          }
        },
        // MuiButton: {
        //   styleOverrides: {
        //     root: {
        //       textTransform: 'none',
        //       fontWeight: 700,
        //       // borderRadius: 12,
        //       // paddingLeft: 16,
        //       // paddingRight: 16,
        //       // paddingTop: 0,
        //       // paddingBottom: 0,
        //     },
        //     containedPrimary: {
        //       background: `linear-gradient(135deg, ${primaryHue} 0%, ${primaryHueLight} 100%)`,
        //       color: '#021012',
        //       boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
        //       '&:hover': {
        //         background: `linear-gradient(135deg, ${primaryHueLight} 0%, ${primaryHue} 100%)`,
        //         boxShadow: '0 10px 28px rgba(0,0,0,0.32)',
        //       },
        //     },
        //     containedSecondary: {
        //       background: `linear-gradient(135deg, ${secondaryHue} 0%, ${secondaryHueLight} 100%)`,
        //       color: '#0b0618',
        //       boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
        //       '&:hover': {
        //         background: `linear-gradient(135deg, ${secondaryHueLight} 0%, ${secondaryHue} 100%)`,
        //         boxShadow: '0 10px 28px rgba(0,0,0,0.32)',
        //       },
        //     },
        //     outlinedPrimary: {
        //       borderWidth: 2,
        //       '&:hover': {
        //         borderWidth: 2,
        //         borderColor: primaryHue,
        //         backgroundColor: alpha(primaryHue, 0.08),
        //       },
        //     },
        //   },
        // },
      },

    });
    }, [darkMode])

  return (
    <ThemeProvider theme={theme}>
      {enableCssBaseline ? <CssBaseline /> : null}
      {children}
    </ThemeProvider>
  )
}
